import { PermissionGroupName } from 'Services/Api/Roles/Types';

export const PERMISSION_CODE_LABEL: Record<string, string> = {
	generate_dashboard_executive_summary: 'Executive Summary',
	view_dashboard_elearning: 'View Training',
	view_dashboard_saq_compliance: 'View SAQ Compliance',
	view_dashboard_scanning: 'View Scanning',
	view_dashboard_my_results: 'View My Results',
	view_dashboard_overview: 'View Overview',
	view_dashboard_phishing: 'View Phishing',
	view_dashboard_spotcheck: 'View Spot Check',
	view_user_activity: 'View User Activity',
	create_force_sync: 'Create',
	add_group: 'Add Group',
	add_tenant: 'Add Tenant',
	change_group_password: 'Change Group Password',
	delete_group: 'Delete Group',
	delete_tenant: 'Delete Tenant',
	edit_group: 'Edit Group',
	edit_tenant: 'Edit Tenant',
	export_groups: 'Export Groups',
	group_manager_view_page: 'View Group Manager',
	move_group: 'Move Groups',
	restore_group: 'Restore Groups',
	restore_tenant: 'Restore Tenant',
	edit_mapping_wizard: 'Edit Mapping',
	view_mapping_wizard: 'View Mapping',
	add_ownership_group: 'Add Ownership Groups',
	delete_ownership_group: 'Delete Ownership Groups',
	edit_ownership_group: 'Edit Ownership Groups',
	export_ownership_group: 'Export Ownership Groups',
	view_ownership_groups: 'View Ownership Groups',
	create_report_current_historical: 'Create Reports',
	view_standard_reports: 'View Reports',
	get_system_by_id: 'Get Systems by ID',
	get_systems: 'Get Systems',
	add_system_role: 'Add System Role',
	clone_system_role: 'Clone System Role',
	delete_system_role: 'Delete System Role',
	edit_system_role: 'Edit System Role',
	export_system_roles: 'Export System Roles',
	system_role_manager_view_page: 'View System Manager',
	view_training_assignment_wizard: 'View Training Assignment',
	activate_disable_user__admin: 'Activate / Disable Admins',
	activate_disable_user__manager: 'Activate / Disable Managers',
	activate_disable_user__owner: 'Activate / Disable Owners',
	activate_disable_user__superadmin: 'Activate / Disable Super Admins',
	activate_disable_user__user: 'Activate / Disable Users',
	add_user__admin: 'Add Admins',
	add_user__manager: 'Add Managers',
	add_user_notification: 'Add User Notifications',
	add_user__owner: 'Add Owners',
	add_user__superadmin: 'Add Super Admins',
	add_user__user: 'Add Users',
	assign__Cybersecurity: 'Assign Cybersecurity Role',
	'assign__Secondary role': 'Assign Secondary Role',
	view_phishing_manager: 'View Phishing Manager',
	delete_user__admin: 'Delete Admins',
	delete_user__manager: 'Delete Managers',
	delete_user__owner: 'Delete Owners',
	delete_user__superadmin: 'Delete Super Admins',
	delete_user__user: 'Delete Users',
	edit_user__admin: 'Edit Admins',
	edit_user__manager: 'Edit Managers',
	edit_user__owner: 'Edit Owners',
	edit_user__superadmin: 'Edit Super Admins',
	edit_user__user: 'Edit Users',
	export_user_audit_log: 'Export User Audit Logs',
	export_users: 'Export Users',
	move_user__admins: 'Move Admins',
	move_user__users: 'Move Users',
	reset_2fa__admin: 'Reset Admin MFA',
	reset_2fa__manager: 'Reset Manager MFA',
	reset_2fa__owner: 'Reset Owner MFA',
	reset_2fa__superadmin: 'Reset Super Admin MFA',
	reset_2fa__user: 'Reset User MFA',
	reset_password__admin: 'Reset Admin Passwords',
	reset_password__manager: 'Reset Manager Passwords',
	reset_password__owner: 'Reset Owner Passwords',
	reset_password__superadmin: 'Reset Super Admin Passwords',
	reset_password__user: 'Reset User Passwords',
	restore_user__admin: 'Restore Admins',
	restore_user__manager: 'Restore Managers',
	restore_user__owner: 'Restore Owners',
	restore_user__superadmin: 'Restore Super Admins',
	restore_user__users: 'Restore Users',
	user_manager_screen_view: 'View User Manager',
	view_user__admin: 'View Admins',
	view_user_audit_log: 'View User Audit Logs',
	view_user__manager: 'View Managers',
	view_user__owner: 'View Owners',
	view_user__superadmin: 'View Super Admins',
	view_user__user: 'View Users',
	export_ownership_groups: 'Export Ownership Groups',
	move_user__admin: 'Move Admin',
	move_user__manager: 'Move Manager',
	move_user__user: 'Move User',
	restore_user__user: 'Restore User'
};

export function getPermissionLabel(code: string): string {
	return PERMISSION_CODE_LABEL[code] ?? code;
}

export const PERMISSION_GROUP_HEADING_BY_NAME = {
	[PermissionGroupName.GroupsManagement]:
		'role.editRole.editRolePermissionGroups.groupsManagement',
	[PermissionGroupName.OwnershipGroupsManagement]:
		'role.editRole.editRolePermissionGroups.ownershipGroupsManagement',
	[PermissionGroupName.SystemRolesManagement]:
		'role.editRole.editRolePermissionGroups.systemRolesManagement',
	[PermissionGroupName.UsersManagement]:
		'role.editRole.editRolePermissionGroups.usersManagement',
	[PermissionGroupName.DashboardManagement]:
		'role.editRole.editRolePermissionGroups.dashboardManagement',
	[PermissionGroupName.ReportsManagement]:
		'role.editRole.editRolePermissionGroups.reportsManagement',
	[PermissionGroupName.ForceSyncManagement]:
		'role.editRole.editRolePermissionGroups.forceSyncManagement',
	[PermissionGroupName.SystemsManagement]:
		'role.editRole.editRolePermissionGroups.systemsManagement',
	[PermissionGroupName.MappingManagement]:
		'role.editRole.editRolePermissionGroups.mappingManagement',
	[PermissionGroupName.PhishingManagerManagement]:
		'role.editRole.editRolePermissionGroups.phishingManagerManagement',
	[PermissionGroupName.TrainingManagement]:
		'role.editRole.editRolePermissionGroups.trainingManagement'
};
